import { AgentBookingWebService as BookingWebService } from '@linktivity/gds-neo';

export type ConfirmationType = BookingWebService.ConfirmationType;
export const ConfirmationType = BookingWebService.ConfirmationType;

export type CancelStatus = BookingWebService.CancelBookingStatus;
export const CancelStatus = BookingWebService.CancelBookingStatus;

export type BookingModelStatus = BookingWebService.BookingModelStatus;
export const BookingModelStatus = BookingWebService.BookingModelStatus;

export type DiscrepancyType = BookingWebService.DiscrepancyType;
export const DiscrepancyType = BookingWebService.DiscrepancyType;

export type DiscrepancyReason = BookingWebService.DiscrepancyReason;
export const DiscrepancyReason = BookingWebService.DiscrepancyReason;

export type DiscrepancyStatus = BookingWebService.DiscrepancyStatus;
export const DiscrepancyStatus = BookingWebService.DiscrepancyStatus;

export type DiscrepancyWaitingStatus =
  BookingWebService.DiscrepancyWaitingStatus;
export const DiscrepancyWaitingStatus =
  BookingWebService.DiscrepancyWaitingStatus;

export type BookingType = BookingWebService.BookingType;
export const BookingType = BookingWebService.BookingType;

export type IssuedStatus = BookingWebService.IssuedStatus;
export const IssuedStatus = BookingWebService.IssuedStatus;

export type CancelReason = BookingWebService.CancellationCancelReason;
export const CancelReason = BookingWebService.CancellationCancelReason;

export type UnitType = BookingWebService.UnitType;
export const UnitType = BookingWebService.UnitType;

export type DiscrepancyInitiator = BookingWebService.DiscrepancyInitiator;
export const DiscrepancyInitiator = BookingWebService.DiscrepancyInitiator;

export type CancelBookingRequestModelStatus =
  BookingWebService.CancelBookingRequestModelStatus;
export const CancelBookingRequestModelStatus =
  BookingWebService.CancelBookingRequestModelStatus;
export type Canceller = BookingWebService.Canceller;
export const Canceller = BookingWebService.Canceller;
